import axios from 'axios';

//API가 401(세션 만료)을 응답하면 전역에서 한 번만 안내한다.
//세션은 서버에서 이미 소멸한 상태라 재시도로는 복구되지 않으므로 재입장 안내가 유일한 처리다.
//학습 화면은 API를 동시에 여러 개 호출하므로 alerted 플래그로 알림 폭주를 막는다.
let alerted = false;

//화면 전체를 안내로 덮는다. window.close()가 브라우저에 막혀 창이 남더라도
//깨진 앱을 계속 조작하는 "좀비 창"이 되지 않게 하는 최후 방어선.
//React 상태와 무관하게 동작해야 하므로 raw DOM으로 그린다.
export function showFatalOverlay(title, detail) {
    if (document.getElementById('auth-guard-overlay')) {
        return;
    }

    const el = document.createElement('div');
    el.id = 'auth-guard-overlay';
    el.style.cssText = 'position:fixed;top:0;left:0;right:0;bottom:0;z-index:2147483647;' +
        'background:#fff;display:flex;flex-direction:column;align-items:center;justify-content:center;' +
        'font-family:sans-serif;text-align:center;padding:20px;';
    el.innerHTML = '<h2 style="margin:0 0 14px;font-size:24px;">' + title + '</h2>' +
        '<p style="margin:0;font-size:16px;color:#555;line-height:1.7;">' + detail + '</p>';

    if (document.body) {
        document.body.appendChild(el);
    }
}

export default function installAuthGuard(message, onExpired) {
    axios.interceptors.response.use(
        function (response) {
            return response;
        },
        function (error) {
            const url = error.config && error.config.url ? error.config.url : '';

            if (error.response && error.response.status === 401 && url.indexOf('/api/') !== -1 && !alerted) {
                alerted = true;
                showFatalOverlay('로그인 정보가 만료되었습니다', message.replace(/\n/g, '<br>'));
                alert(message);

                if (onExpired) {
                    onExpired();
                }
            }

            return Promise.reject(error);
        }
    );
}
